export { DMS_MODULE } from '../constants';
export const NAME = 'ServPersProvoz';
export const CRUMB_LABEL_KEY = 'edtServPersProvoz';
